import { CAMPAIGN_STATE } from '@/lib/types';

export const AUTO_SYNC_CHECK_THROTTLE_MS = 15 * 60 * 1000; // once per 15 min per campaign

/**
 * Pure decision for auto-pull-on-open (#5566 Req 1): should the external-change check run now?
 * Only live campaigns have a Google Ads counterpart that can drift, and the check is throttled per
 * campaign so in-session navigation doesn't re-probe. Kept dependency-free so it is unit-testable
 * without a React/Jotai render harness.
 */
export function shouldRunAutoSync({
  state,
  lastCheckedMs,
  nowMs,
}: {
  state: string | undefined;
  lastCheckedMs: number | undefined;
  nowMs: number;
}): boolean {
  if (state !== CAMPAIGN_STATE.LIVE) return false;
  if (lastCheckedMs !== undefined && nowMs - lastCheckedMs < AUTO_SYNC_CHECK_THROTTLE_MS) return false;
  return true;
}
